import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSheet,{staticClass:"pa-3",staticStyle:{"margin-bottom":"1px","background-color":"#CFD8DC"},attrs:{"elevation":"0","width":"100%"}},[_c('div',[_vm._v("Name: "),_c('b',[_vm._v(_vm._s(_vm.name))])]),_c('div',[_vm._v("State: "),_c('b',[_vm._v(_vm._s(_vm.state))])]),_c('div',[_vm._v("Passed: "),_c('b',[_vm._v(_vm._s(_vm.passed))])]),_c('div',[_vm._v("Report Message: "),_c('b',[_vm._v(_vm._s(_vm.reportMessage || 'None'))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }